import { Subject, Observable } from 'rxjs';
import { publish } from 'rxjs/operators';
export function lazyConnection(options) {
    let obs = new Observable(observer => {
        let subject = new Subject();
        let subscription = subject.subscribe(observer);
        options.start(subject);
        return () => {
            subscription.unsubscribe();
            options.stop();
        };
    });
    return obs.pipe(publish()).refCount();
}
//# sourceMappingURL=lazy-connection.js.map